import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, change} from 'redux-form';
import {SelectInput} from 'admin-on-rest';
import DiscountBXGYInstructions from './DiscountBXGYInstructions';
import DiscountItemTable from './DiscountItemTable';
import DiscountConditionTables from './DiscountConditionTables';
import {viewStyles} from "../shared/styles-view";

/**
 * A component for containing and processing shared data from DiscountItemTables
 *
 */
class DiscountItemTables extends Component {
    constructor(props) {
        super(props);
        let presetDiscount = null;
        let showBuyGet = false;
        if (props.dependsOnValue && props.dependsOnValue.preset_custom) {
            const preset_custom = props.dependsOnValue.preset_custom;
            if (preset_custom === 'preset_products_any') {
                presetDiscount = 'buy_type = ITEM | get_type = ANY';
            } else if (preset_custom === 'preset_products_same') {
                presetDiscount = 'buy_type = ITEM | get_type = SAME';
            } else if (preset_custom === 'preset_categories_same') {
                presetDiscount = 'buy_type = CATEGORY | get_type = SAME';
            } else if (preset_custom === 'custom') {
                showBuyGet = true;
            }
        }


        this.state = {
            buyAndOr: null,
            buyList: [],
            conditions: {
                dbas: [],
                locations: [],
                dbaInclude: '',
                locationInclude: ''
            },
            getAndOr: null,
            getList: [],
            item_action: '',
            item_condition: '',
            presetDiscount: presetDiscount,
            restrictBuyOption: null,
            restrictGetOption: null,
            scope: '',
            scopeMessage: null,
            showBuyGet: showBuyGet
        };
    }

    componentDidMount() {
        this.processDiscountData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.buyQty !== prevProps.buyQty ||
            this.props.getQty !== prevProps.getQty ||
            this.props.discountAmount !== prevProps.discountAmount ||
            this.props.priceDifference !== prevProps.priceDifference ||
            this.props.itemAction !== prevProps.itemAction
        ) {
            this.processDiscountData();
        }
    }

    handleSetDiscountType = (e, value) => {
        let presetDiscount = null;
        let showBuyGet = false;

        if (value === 'preset_products_any') {
            presetDiscount = 'buy_type = ITEM | get_type = ANY';
        } else if (value === 'preset_products_same') {
            presetDiscount = 'buy_type = ITEM | get_type = SAME';
        } else if (value === 'preset_categories_same') {
            presetDiscount = 'buy_type = CATEGORY | get_type = SAME';
        } else if (value === 'custom') {
            showBuyGet = true;
        }

        this.setState({
            buyAndOr: null,
            buyList: [],
            getAndOr: null,
            getList: [],
            presetDiscount: presetDiscount,
            showBuyGet: showBuyGet
        }, () => {
            this.processDiscountData();
        });
    };

    handleTableChange = (list, andOr, tableType) => {

        let restrictType = null;

        // If a table has made an "All" selection, restrict the other table's options
        if (list.length > 0) {
            if (list[0].type === 'type') {
                restrictType = 'type';
            }
            if (list[0].type === 'categories') {
                restrictType = 'categories';
            }
        }

        // Update the Buy list and process
        if (tableType === 'buy') {
            this.setState({
                buyAndOr: andOr,
                buyList: list,
                restrictGetOption: restrictType
            }, () => {
                this.processDiscountData();
            });
        }

        // Update the Get list and process
        if (tableType === 'get') {
            this.setState({
                getAndOr: andOr,
                getList: list,
                restrictBuyOption: restrictType
            }, () => {
                this.processDiscountData();
            });
        }
    };

    handleConditionChange = (dbaList, locationList, dbaInclude, locationInclude) => {
        let conditions = {
            dbas: dbaList,
            locations: locationList,
            dbaInclude: dbaInclude,
            locationInclude: locationInclude
        };
        this.setState({
            conditions: conditions
        }, () => {
            this.processDiscountData();
        });

    };

    /**
     * Assemble field values based on form changes
     */
    processDiscountData = () => {
        let conditions = JSON.parse(JSON.stringify(this.state.conditions));

        // Assemble Item Action (percent_off)

        let itemAction = this.props.itemAction;
        const priceDifference = (this.props.priceDifference) ? this.props.priceDifference : 'free';
        const discountAmount = (this.props.discountAmount && priceDifference === 'percentage')
            ? this.props.discountAmount :
            100;
        itemAction = 'percent_off = ' + discountAmount;

        // Assemble Item Condition (dba, location)

        let itemCondition = '';

        // Assemble DBA condition
        if (conditions.dbas && conditions.dbas.length && conditions.dbaInclude) {
            let dLength = conditions.dbas.length;
            let dInclude = (conditions.dbaInclude === 'equals') ? ' = ' : ' != ';
            itemCondition += 'dba' + dInclude;
            for (let d = 0; d < dLength; d++) {
                itemCondition += conditions.dbas[d].id;
                if (d < (dLength - 1)) {
                    itemCondition += ',';
                }
            }
        }

        // Assemble Location condition
        if (
            (conditions.dbas && conditions.dbas.length) &&
            (conditions.locations && conditions.locations.length)
        ) {
            itemCondition += ' AND ';
        }
        if (conditions.locations && conditions.locations.length && conditions.locationInclude) {
            let lLength = conditions.locations.length;
            let lInclude = (conditions.locationInclude === 'equals') ? ' = ' : ' != ';
            itemCondition += 'location' + lInclude;
            for (let l = 0; l < lLength; l++) {
                itemCondition += conditions.locations[l].id;
                if (l < (lLength - 1)) {
                    itemCondition += ',';
                }
            }
        }

        // Assemble Item Scope (Preset or Custom)

        let qtyScope = 'bxgy_type = ' + this.props.buyQty + ',' + this.props.getQty;
        let presetDiscount = this.state.presetDiscount;
        let resetScope = false;
        let scopeMessage = '';
        let scope = '';

        if (presetDiscount) {

            // If a preset Discount has been selected, assemble the scope
            scope = qtyScope + ' | ' + presetDiscount + (itemCondition ? ' AND ' + itemCondition : '');

        } else {

            // Otherwise, assemble Custom Item Scope (bxgy_type, buy_, get_ values)
            let buyList = JSON.parse(JSON.stringify(this.state.buyList));
            let getList = JSON.parse(JSON.stringify(this.state.getList));

            let buyScope = '';
            let buyAndOr = this.state.buyAndOr;
            let getScope = '';
            let getAndOr = this.state.getAndOr;

            if (!buyList.length || !getList.length) {
                // If no items are added, display message without assembling scope
                resetScope = true;
                scopeMessage = 'Both Buy Items and Get Items are required to assemble a Scope.';
            } else {
                // Cycle through Buy Items
                for (let b = 0; b < buyList.length; b++) {
                    let bThis = buyList[b];
                    let bPrev = buyList[(b - 1)];
                    // Rename "All" items
                    if (bThis.name === 'All Products') {
                        bThis.name = 'ANY';
                    }
                    if (bThis.name === 'All Categories') {
                        bThis.name = 'CATEGORY';
                        bThis.type = 'type';
                    }

                    if (b === 0) {
                        buyScope += 'buy_' + bThis.type + ' = ' + bThis.name;
                    } else if (bPrev) {
                        if (bPrev.type === bThis.type) {
                            // Connect Buy selection of the same type
                            buyScope += (buyAndOr === 'AND') ? '&' : ',';
                            buyScope += bThis.name;
                        } else {
                            // Connect Buy selection of a different type (deprecated?)
                            buyScope += (buyAndOr === 'AND')
                                ? ' AND buy_' + bThis.type + ' = '
                                : ' OR buy_' + bThis.type + ' = ';
                            buyScope += bThis.name;
                        }
                    }
                }

                // Cycle through Get Items
                for (let g = 0; g < getList.length; g++) {
                    let gThis = getList[g];
                    let gPrev = getList[(g - 1)];
                    // Rename "All" items
                    if (gThis.name === 'All Products') {
                        gThis.name = 'ANY';
                    }
                    if (gThis.name === 'All Categories') {
                        gThis.name = 'CATEGORY';
                        gThis.type = 'type';
                    }

                    if (g === 0) {
                        getScope += 'get_' + gThis.type + ' = ' + gThis.name;
                    } else if (gPrev) {
                        if (gPrev.type === gThis.type) {
                            // Connect Get selection of the same type
                            getScope += (getAndOr === 'AND') ? '&' : ',';
                            getScope += gThis.name;
                        } else {
                            // Connect Get selection of a different type (deprecated?)
                            getScope += (getAndOr === 'AND')
                                ? ' AND get_' + gThis.type + ' = '
                                : ' OR get_' + gThis.type + ' = ';
                            getScope += gThis.name;
                        }
                    }
                }

                // Change scope terms based on matching
                if (
                    buyScope.indexOf('buy_type = ANY') !== -1 &&
                    getScope.indexOf('get_type = ANY') !== -1
                ) {
                    // If Buy = All Products and Get = All Products, change scope terms
                    buyScope = 'buy_type = ITEM';
                } else if (
                    buyScope.indexOf('buy_category = CATEGORY') !== -1 &&
                    getScope.indexOf('get_category = CATEGORY') !== -1
                ) {
                    // If Buy = All Categories and Get = All Categories, change scope terms
                    buyScope = 'buy_type = CATEGORY';
                    getScope = 'get_type = SAME';
                } else {
                    // Continue with normal buy and get scope values
                }

                scope = qtyScope + ' | ' + buyScope + ' | ' + getScope + (itemCondition ? ' AND ' + itemCondition : '');
            }
        }

        if (resetScope) {
            scope = '';
        } else {
            scopeMessage = null;
        }

        this.setState({
            item_action: itemAction,
            item_condition: itemCondition,
            scope: scope,
            scopeMessage: scopeMessage
        }, () => {
            this.props.dispatch(change('record-form', 'item_action', itemAction));
            this.props.dispatch(change('record-form', 'item_condition', itemCondition));
            this.props.dispatch(change('record-form', 'scope', scope));
        });
    };

    render() {
        const {
            buyQty,
            discountAmount,
            getQty,
            itemAction,
            priceDifference,
            type
        } = this.props;

        const {
            restrictBuyOption,
            restrictGetOption,
            scope,
            scopeMessage,
            showBuyGet
        } = this.state;

        const buySummary = `Select all Products, all Categories, or add one or more specific Categories and/or 
        Products that the Customer must purchase to fulfill the "Buy" criteria of the BXGY Discount.`;
        const buyTooltip = `Assemble rows of items to fulfill the "Buy" criteria of the BXGY Discount.`;

        const getSummary = `Add one or more Product Types, Categories, and/or Products that the Customer will receive 
        per the "Get" criteria of the BXGY Discount.`;
        const getTooltip = `Assemble rows of items to detail the "Get" items the Customer will receive per the BXGY 
        Discount`;

        return (
            <div>
                {type && priceDifference &&
                    <div>
                        <hr style={viewStyles.divider}/>
                        <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                        {/* Instructions Expansion Panel */}

                        <DiscountBXGYInstructions type={type}/>

                        {/* Select Preset or Custom BXGY Discount */}

                        <span style={viewStyles.fieldTitle}>
                        4b. Select Preset or Custom Discount
                    </span>

                        <p style={{...viewStyles.fieldParagraph, ...viewStyles.noMargin}}>
                            Select a Preset BXGY Discount, or select "Custom" to assemble Buy and Get items.
                        </p>
                        <hr style={viewStyles.break}/>

                        <Field name="preset_custom"
                               component={SelectInput}
                               choices={[
                                   {
                                       id: 'preset_products_any',
                                       name: 'Buy Any X Products = Get Any Y Products of Equal or Lesser Value'
                                   },
                                   {
                                       id: 'preset_products_same',
                                       name: 'Buy Any X Products = Get Y Same Products'
                                   },
                                   {
                                       id: 'preset_categories_same',
                                       name: 'Buy X Products From Any Category = Get Y Products From Same Category'
                                   },
                                   {id: 'custom', name: 'Make a Custom BXGY Discount'}
                               ]}
                               label="Is This a Preset or Custom Discount?*"
                               onChange={this.handleSetDiscountType}
                               style={viewStyles.filterLeft}
                               elStyle={viewStyles.filterLeft}
                        />

                        <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                        {/* BXGY Discount Buy/Get Tables */}

                        {buyQty && getQty && showBuyGet &&
                            <Fragment>
                                <hr style={viewStyles.divider}/>
                                <span style={viewStyles.fieldTitle}>
                            4c. Add Buy and Get Items
                        </span>
                            </Fragment>
                        }

                        {buyQty && showBuyGet &&
                            <DiscountItemTable
                                tableType="buy"
                                tableTypeLabel="Buy"
                                summary={buySummary}
                                tooltip={buyTooltip}
                                onTableUpdate={this.handleTableChange}
                                buyQty={buyQty}
                                getQty={getQty}
                                restrictOptions={restrictBuyOption}
                                type={type}
                            />
                        }

                        {getQty && showBuyGet &&
                            <DiscountItemTable
                                tableType="get"
                                tableTypeLabel="Get"
                                summary={getSummary}
                                tooltip={getTooltip}
                                onTableUpdate={this.handleTableChange}
                                buyQty={buyQty}
                                getQty={getQty}
                                restrictOptions={restrictGetOption}
                                type={type}
                            />
                        }

                        <hr style={viewStyles.break}/>

                        {discountAmount &&
                            <div>
                                <hr style={viewStyles.divider}/>

                                {/* Restrict by DBA/Location */}

                                <span style={viewStyles.fieldTitle}>
                            {(showBuyGet) ? '4d' : '4c'}. Restrict by DBA and/or Location
                        </span>
                                <DiscountConditionTables
                                    buyQty={buyQty}
                                    getQty={getQty}
                                    type={type}
                                    onConditionUpdate={this.handleConditionChange}
                                />

                                {/* Discount Summary */}

                                <span style={viewStyles.fieldHeader}>BXGY Discount Summary</span>

                                <span style={{...viewStyles.fieldDescriptionTop, ...viewStyles.marginBottom}}>
                            The <em>Price Difference</em> and <em>Discount Amount</em> sets the <em>Item Action</em> for
                            this Discount.
                        </span>
                                <span
                                    style={{...viewStyles.fieldLabel, ...viewStyles.rowShowField, ...viewStyles.marginLeft}}>
                            Item Action: </span>
                                <span style={{...viewStyles.fieldInput, ...viewStyles.rowShowField}}>{itemAction}</span>
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                <span style={{...viewStyles.fieldDescriptionTop, ...viewStyles.marginBottom}}>
                            The <strong>Buy Items</strong> and <strong>Get Items</strong> above will assemble
                            the <em>scope</em> of this BXGY Discount. The <em>scope</em> must contain logic for both
                            Buy and Get items.
                        </span>
                                <span
                                    style={{...viewStyles.fieldLabel, ...viewStyles.rowShowField, ...viewStyles.marginLeft}}>
                            Scope: </span>
                                {scope && scope !== '' &&
                                    <span style={{...viewStyles.fieldInput, ...viewStyles.rowShowField, ...viewStyles.scopeWrap}}>
                            {scope}
                        </span>
                                }
                                {scopeMessage &&
                                    <span
                                        style={{...viewStyles.fieldInput, ...viewStyles.rowShowField, ...viewStyles.error}}>
                            {scopeMessage}
                        </span>
                                }
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                <span style={{...viewStyles.fieldDescriptionTop, ...viewStyles.marginBottom}}>
                        </span>
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const buyQty = (form.values.buy_qty) ? parseInt(form.values.buy_qty, 10) : 0;
        const getQty = (form.values.get_qty) ? parseInt(form.values.get_qty, 10) : 0;
        const itemAction = (form.values.item_action) ? form.values.item_action : '';
        const discountAmount = (form.values.discount_amount) ? parseFloat(form.values.discount_amount) : 100;
        const priceDifference = (form.values.price_difference) ? form.values.price_difference : null;
        const productType = (form.values.type) ? form.values.type : null;

        return {
            buyQty: buyQty,
            discountAmount: discountAmount,
            getQty: getQty,
            itemAction: itemAction,
            priceDifference: priceDifference,
            type: productType,
        }
    }
    return {}
};

DiscountItemTables.propTypes = {
    addField: PropTypes.bool,
    buyQty: PropTypes.number,
    discountAmount: PropTypes.number,
    getQty: PropTypes.number,
    itemAction: PropTypes.string,
    priceDifference: PropTypes.string,
    type: PropTypes.string
};

DiscountItemTables.defaultProps = {
    addField: true,
    buyQty: 0,
    discountAmount: 100,
    getQty: 0,
    itemAction: '',
    priceDifference: 'free',
    type: null
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(DiscountItemTables);



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountItemTables.js